import type { SxProps, Theme } from "@mui/material/styles";

/** Accordion das subseções de Insights (padrão FluxZap). */
export const insightsSubsectionAccordionSx: SxProps<Theme> = {
  borderRadius: 2,
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
  "&:before": { display: "none" },
  boxShadow: "none",
};

export const insightsSubsectionAccordionSummarySx: SxProps<Theme> = {
  px: { xs: 1.25, sm: 1.5 },
  py: 1,
  minHeight: 56,
  "& .MuiAccordionSummary-content": {
    my: 0.5,
    alignItems: "flex-start",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "text.secondary",
  },
};

export const insightsSubsectionAccordionDetailsSx: SxProps<Theme> = {
  px: { xs: 1.25, sm: 1.5 },
  pt: 0,
  pb: { xs: 1.25, sm: 1.5 },
  minWidth: 0,
  maxWidth: "100%",
  overflow: "hidden",
};

/** Caixa do ícone no cabeçalho da subseção (espelha SectionHeader em escala menor). */
export const insightsSubsectionIconBoxSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  borderRadius: 1.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  color: "primary.main",
  flexShrink: 0,
};

/** Painel flat (sem acordeão) — título + conteúdo sempre visível. */
export const insightsSubsectionFlatPanelSx: SxProps<Theme> = {
  borderRadius: 2,
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
  boxShadow: "none",
};

export const insightsSubsectionFlatHeaderSx: SxProps<Theme> = {
  px: { xs: 1.25, sm: 1.5 },
  py: 1.25,
  borderBottom: "1px solid",
  borderColor: "divider",
};
